// useAnnonceApi.ts


import { TAnnonce } from '../../models/annonce/annonce';
import { useApiClient } from '../apiClients';
import { ENDPOINTS_ANNONCES } from './endpoints';

export const useAnnonceApi = () => {
  const apiClient = useApiClient();

  // Récupérer toutes les annonces
  const getAllAnnonces = (flag?: string) => {
    if (flag) {
      return apiClient.get<TAnnonce[]>(ENDPOINTS_ANNONCES.GET_ALL, {
        params: { flag },
      });
    }
    return apiClient.get<TAnnonce[]>(ENDPOINTS_ANNONCES.GET_ALL);
  };

  // Récupérer toutes les annonces actives
  const getAnnoncesActives = (flag?: string) => {
    if (flag) {
      return apiClient.get<TAnnonce[]>(ENDPOINTS_ANNONCES.GET_ACTIVE, {
        params: { flag },
      });
    }
    return apiClient.get<TAnnonce[]>(ENDPOINTS_ANNONCES.GET_ACTIVE);
  };

  // Récupérer une annonce par ID
  const getAnnonceById = (annonceId: number) =>
    apiClient.get<TAnnonce>(ENDPOINTS_ANNONCES.GET_BY_ID(annonceId));

  // Créer une annonce
  const createAnnonce = (annonce: TAnnonce) =>
    apiClient.post<TAnnonce>(ENDPOINTS_ANNONCES.CREATE_ANNONCE, annonce);

  // Mettre à jour une annonce existante
  const updateAnnonce = (annonceId: number, annonce: TAnnonce) =>
    apiClient.put<TAnnonce>(ENDPOINTS_ANNONCES.UPDATE_ANNONCE(annonceId), annonce);

  // Supprimer une annonce
  const deleteAnnonce = (annonceId: number) =>
    apiClient.delete(ENDPOINTS_ANNONCES.DELETE_ANNONCE(annonceId));

  // Upload d'image pour une annonce (optionnel, si besoin)
  // Nécessite un endpoint adapté pour accepter un FormData
  const uploadAnnonceImage = (annonceId: number, formData: FormData) => {
    return apiClient.post<TAnnonce>(ENDPOINTS_ANNONCES.UPLOAD_IMAGE(annonceId), formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  };

  return {
    getAllAnnonces,
    getAnnoncesActives,
    getAnnonceById,
    createAnnonce,
    updateAnnonce,
    deleteAnnonce,
    uploadAnnonceImage, // Optionnel
  };
};
